<dgx-components-badge
  *ngIf="promotionActive"
  [spacing]="2"
  [theme]="'decoration-3'"
  class="protection-details-page__quote-offer__promotional-badge pt-3"
>
  <div class="protection-details-page__quote-offer__promotional-badge-content">
    <p
      class="protection-details-page__quote-offer__promotional-badge-content-title"
    >
      {{
        'PROTECTION_DETAILS_QUOTE_OFFER_PROMOTIONAL_BADGE'
          | translate
            : {
                discountedMonthPercentage: discountedMonthPercentage,
                discountedMonthsCount: discountedMonthsCount
              }
      }}
    </p>
    <dgx-components-icon [name]="'gift'" [size]="'sm'" />
  </div>
</dgx-components-badge>

<ng-container *ngIf="stacked; else inline">
  <p class="protection-details-page__quote-offer mt-6">
    {{
      'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
        | translate
          : {
              brandName: quoteBrand
            }
    }}
  </p>
  <p class="protection-details-page__quote-offer mt-2">
    <ng-container *ngTemplateOutlet="quotePriceTemplate" />
  </p>
</ng-container>

<ng-template #inline>
  <p class="protection-details-page__quote-offer my-3">
    {{
      'PROTECTION_DETAILS_QUOTE_OFFER_LEADING_TEXT'
        | translate
          : {
              brandName: quoteBrand
            }
    }}
    <ng-container *ngTemplateOutlet="quotePriceTemplate" />
  </p>
</ng-template>

<ng-template #quotePriceTemplate>
  <ng-container *ngIf="promotionActive; else promotionInactive">
    for
    <span class="protection-details-page__quote-offer__price-strikethrough pr-1"
      >{{ quoteOriginalPrice | currencyFormat }}
    </span>
    <span>{{
      quoteOriginalPrice | quoteOfferPriceDiscounted : 0.5 | currencyFormat
    }}</span>
    a month
  </ng-container>
</ng-template>

<ng-template #promotionInactive>
  {{
    'PROTECTION_DETAILS_QUOTE_OFFER_PRICE'
      | translate
        : {
            quotePayment: quoteOriginalPrice | currencyFormat
          }
  }}
</ng-template>
<p class="protection-details-page__quote-offer__cancel-anytime mt-2">
  {{ 'PROTECTION_DETAILS_CANCEL_ANYTIME_MONTHLY' | translate }}
</p>
<p
  class="protection-details-page__quote-offer__cancel-anytime-caption typog-caption-regular typog-body my-2"
>
  {{ 'PROTECTION_DETAILS_CANCEL_OBSERVATION' | translate }}
</p>
